import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ReCaptcha } from 'react-recaptcha-v3';
import { Icon, Form, Input, Button, message, Checkbox } from 'antd';
import { hasErrors } from '../../common/utils';
import { userSignUp } from '../../common/fetch';
import { CAPTCHA_SITE_KEY } from '../../config/constants';
import { FormWrapper, CheckWrapper } from './style';

class Wrapper extends Component {
	state = {
		isCheck: false,
		num: parseInt((Math.random() * 100) % 11, 10) + 1
	};

	handleSubmit = async (e) => {
		e.preventDefault();
		const { getFieldValue } = this.props.form;
		const { history } = this.props;
		const { isCheck } = this.state;
		const { location } = this.props;
		let referral = '';
		if (location.search.indexOf('affiliation_code') >= 0) {
			referral = location.search.split('=')[1];
		} else {
			referral = 'holladash';
		}
		if (!isCheck) {
			message.warning('Check the terms and policy');
			return;
		}
		if (
			getFieldValue('email') === undefined ||
			getFieldValue('password') === undefined
		) {
			message.warning('Fill the inputs.');
			return;
		}
		if (getFieldValue('password') !== getFieldValue('checkPw')) {
			message.warning('Password is not correct');
			return;
		}
		const body = {
			email: getFieldValue('email'),
			password: getFieldValue('password'),
			otp_code: '',
			referral,
			captcha: this.recaptcha
		};
		try {
			await userSignUp(body);
			message.success('Check your email to confirm');
			history.push({
				pathname: '/recover',
				state: { step: 'step2', isSignup: true },
			});
		} catch (error) {
			console.error(error);
			this.captcha.execute();
			message.warn('Error : ' + error.data.message);
		}
	};

	handleCheck = () => {
		this.setState({ isCheck: !this.state.isCheck });
	};

	setRef = (el) => {
		this.captcha = el;
	};

	onVerifyCallback = (value) => {
		this.recaptcha = value;
	};

	onExpiredCallback = () => {
		this.recaptcha = '';
		this.captcha.execute();
	};

	render() {
		const {
			getFieldDecorator,
			getFieldsError,
			getFieldError,
			isFieldTouched
		} = this.props.form;
		const { isCheck } = this.state;
		const emailError = isFieldTouched('email') && getFieldError('email');
		const passwordError =
			isFieldTouched('password') && getFieldError('password');
		const checkPwError =
			isFieldTouched('checkPw') && getFieldError('checkPw');

		return (
			<FormWrapper>
				<Form onSubmit={this.handleSubmit}>
					<h3>Sign Up</h3>
					<Form.Item
						validateStatus={emailError ? 'error' : ''}
						help={emailError || ''}
					>
						{getFieldDecorator('email', {
							rules: [
								{
									required: true,
									message: 'Please input your email!'
								},
								{
									type: 'email',
									message: 'The input is not valid E-mail!'
								}
							]
						})(
							<Input
								prefix={
									<Icon
										type="mail"
										style={{ color: '#42454D' }}
									/>
								}
								name="email"
								placeholder="Email"
							/>
						)}
					</Form.Item>
					<Form.Item
						validateStatus={passwordError ? 'error' : ''}
						help={passwordError || ''}
					>
						{getFieldDecorator('password', {
							rules: [
								{
									required: true,
									message: 'Please input your Password!'
								},
								{
									pattern: /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/,
									message:
										'Minimum eight characters, at least one letter and one number:'
								}
							]
						})(
							<Input
								prefix={
									<Icon
										type="lock"
										style={{ color: '#42454D' }}
									/>
								}
								type="password"
								placeholder="Password"
							/>
						)}
					</Form.Item>
					<Form.Item
						validateStatus={checkPwError ? 'error' : ''}
						help={checkPwError || ''}
					>
						{getFieldDecorator('checkPw', {
							rules: [
								{
									required: true,
									message: 'Please input your checkPw!'
								}
							]
						})(
							<Input
								prefix={
									<Icon
										type="lock"
										style={{ color: '#42454D' }}
									/>
								}
								type="password"
								placeholder="Check Password"
							/>
						)}
					</Form.Item>
					<Form.Item>
						<CheckWrapper className="check-area">
							<Checkbox value={isCheck} onChange={this.handleCheck} >
								I have read and agree to the{' '}
								<a
								    href="https://www.hollaex.com/terms-and-conditions"
									target="_blank"
									rel="noopener noreferrer"
								>
									General Terms
								</a>{' '}
								and{' '}
								<a
									href="https://www.hollaex.com/privacy-policy"
									target="_blank"
									rel="noopener noreferrer"
								>
									Privacy Policy.
								</a>
							</Checkbox>
						</CheckWrapper>
					</Form.Item>
					<div>
						<ReCaptcha
							sitekey={CAPTCHA_SITE_KEY}
							verifyCallback={this.onVerifyCallback}
							expiredCallback={this.onExpiredCallback}
							ref={this.setRef}
						/>
						<Button
							block
							type="primary"
							htmlType="submit"
							disabled={hasErrors(getFieldsError()) || !isCheck}
						>
							Sign Up
						</Button>
						<div className="link">
							Already have an account?&nbsp;
							<Link to="/login">Go to the login page.</Link>
						</div>
						<div className="link">
							Haven't received the email?&nbsp;
							<Link to="/email">Request another email here.</Link>
						</div>
					</div>
				</Form>
			</FormWrapper>
		);
	}
}

const WrappedHorizontalLoginForm = Form.create({ name: 'login form' })(Wrapper);

export default WrappedHorizontalLoginForm;
